// @flow

import React from 'react';
import {
  Radio,
  Input,
  Wrapper,
} from './atoms';
import type { Props } from './types';

export default ({
  onChange, name, checked, ...rest
}: Props) => (
  <Wrapper>
    <Input
      type="Radio"
      checked={checked}
      onChange={(e: SyntheticInputEvent<HTMLInputElement>) => onChange(e)}
      name={name}
      {...rest}
    />
    <Radio checked={checked} />
  </Wrapper>
);
